module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFAQMAAAC3obSmAAAABlBMVEUAAAAAAAClZ7nPAAAAAnRSTlMADpEr4D8AAAASSURBVAjXY2hg4GAQYFBgcAAABbIA+Zl88MsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// D:/TELEMED-FINAL/telemed/src/assets/img/pattern/overlay-pattern.png
// module id = ../../../../../src/assets/img/pattern/overlay-pattern.png
// module chunks = styles